import { Controller } from 'stimulus';

/**
 * Logs events to analytics whenever this element is clicked. Specify the name
 * of the event in data-event. All other data properties will be sent to analytics as well.
 */
export default class CopyToClipboard extends Controller {
  async click(e) {
    const input = this.element.querySelector('.clipboard-data');
    const wasPassword = input.type === 'password';

    // execCommand can't copy a password field, so flip to text for the copy and back.
    if (wasPassword) input.type = 'text';
    input.select();
    document.execCommand('copy');
    if (wasPassword) input.type = 'password';

    e.target.textContent = 'Copied!'
    setTimeout(() => e.target.textContent = "Copy", 3000);
  }
}
